// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category_outer_container {
  /* border: 1px solid black; */
  width: 100%;
}
.categoryOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Actual form box */
.addCategoryForm {
  width: 400px;
  background-color: rgb(235, 240, 234);
  padding: 20px 25px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

/* Close button inside form */
.categoryCloseButton {
  border: none;
  background: transparent;
  color: #555;
  font-size: 22px;
  cursor: pointer;
  position: absolute;
  right: 15px;
  top: 10px;
}

/* Button to open form */
.addCategoryButton {
  padding: 8px 5px;
  font-size: 12px;

  cursor: pointer;
  position: absolute;
  right: 30px;
  top: 15px;
}

/* Table styles */
.categoryTable {
  width: 100%;
  border-collapse: collapse;
  margin-top: 60px;
  position: relative;
  height: 350px;
  overflow: scroll;
}
.categoryTable td {
  overflow: scroll;
  width: 35%;
}
.categoryTable td::-webkit-scrollbar {
  display: none;
}
.editCategoryButton {
  border-right: 3px solid black;
  padding-right: 1rem;
}

.deleteCategoryButton {
  padding-left: 1rem;
}

.add {
  font-size: 1.2rem;
}
.add_buttons {
  /* width: 60px;
  border-radius: 3px; */

  /* font-size: 14px; */
  margin-left: 289px;
  margin-top: 5px;
}

.categoryTable table {
  width: 100%;
  /* border-collapse: separate; */
  border-spacing: 0 5px;
  margin-top: -5px;
  border: 1px solid #d9e3d9;
}

.categoryTable th {
  background-color: #deecdd;
  position: sticky;
  top: 0;
  text-align: center;
  padding: 4px 1px;
}
.categoryTable td {
  font-weight: 600;
  font-size: 11px;
  text-align: center;
  padding: 4px 1px;
}

.categoryTable tr:nth-child(odd) {
  background-color: #c6bcbc37;
}
.categoryTable td {
  font-size: 11px;
}
.categoryOptionSelect {
  width: 50%;
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.categoryOptionSelect ::--webkit-scrollbar{
  width: 1px;
  border-radius: 2px;

}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .addCategoryButton {
    background-color: #84c7ae;
    border: none;
    color: white;
    padding: 9px 10px;
    font-size: 13px;
    border-radius: 4px;
    cursor: pointer;
    position: absolute;
    right: 30px;
    top: 15px;
  }

  .categoryTable td {
    font-size: 16px;
  }
  .categoryTable th {
    background-color: #deecdd;
    position: sticky;
    top: 0;
    text-align: center;
    padding: 4px 1px;
  }
}

/* Small Desktops & Laptops: 1025px to 1439px */
@media screen and (min-width: 1025px) and (max-width: 1440px) {
  .categoryTable {
    width: 100%;
    border-collapse: collapse;
    margin-top: 60px;
    position: relative;
    font-size: 20px;
  }
  .categoryTable td {
    font-size: 13px;
  }
  .categoryTable th {
    background-color: #deecdd;
    position: sticky;
    top: 0;
    text-align: center;
    padding: 4px 1px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/Category/Category.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,eAAe;;EAEf,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE;uBACqB;;EAErB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,kBAAkB;;AAEpB;AACA;EACE;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,MAAM;IACN,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,MAAM;IACN,kBAAkB;IAClB,gBAAgB;EAClB;AACF","sourcesContent":[".category_outer_container {\n  /* border: 1px solid black; */\n  width: 100%;\n}\n.categoryOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.4);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n/* Actual form box */\n.addCategoryForm {\n  width: 400px;\n  background-color: rgb(235, 240, 234);\n  padding: 20px 25px;\n  border-radius: 8px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n/* Close button inside form */\n.categoryCloseButton {\n  border: none;\n  background: transparent;\n  color: #555;\n  font-size: 22px;\n  cursor: pointer;\n  position: absolute;\n  right: 15px;\n  top: 10px;\n}\n\n/* Button to open form */\n.addCategoryButton {\n  padding: 8px 5px;\n  font-size: 12px;\n\n  cursor: pointer;\n  position: absolute;\n  right: 30px;\n  top: 15px;\n}\n\n/* Table styles */\n.categoryTable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 60px;\n  position: relative;\n  height: 350px;\n  overflow: scroll;\n}\n.categoryTable td {\n  overflow: scroll;\n  width: 35%;\n}\n.categoryTable td::-webkit-scrollbar {\n  display: none;\n}\n.editCategoryButton {\n  border-right: 3px solid black;\n  padding-right: 1rem;\n}\n\n.deleteCategoryButton {\n  padding-left: 1rem;\n}\n\n.add {\n  font-size: 1.2rem;\n}\n.add_buttons {\n  /* width: 60px;\n  border-radius: 3px; */\n\n  /* font-size: 14px; */\n  margin-left: 289px;\n  margin-top: 5px;\n}\n\n.categoryTable table {\n  width: 100%;\n  /* border-collapse: separate; */\n  border-spacing: 0 5px;\n  margin-top: -5px;\n  border: 1px solid #d9e3d9;\n}\n\n.categoryTable th {\n  background-color: #deecdd;\n  position: sticky;\n  top: 0;\n  text-align: center;\n  padding: 4px 1px;\n}\n.categoryTable td {\n  font-weight: 600;\n  font-size: 11px;\n  text-align: center;\n  padding: 4px 1px;\n}\n\n.categoryTable tr:nth-child(odd) {\n  background-color: #c6bcbc37;\n}\n.categoryTable td {\n  font-size: 11px;\n}\n.categoryOptionSelect {\n  width: 50%;\n  padding: 4px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n.categoryOptionSelect ::--webkit-scrollbar{\n  width: 1px;\n  border-radius: 2px;\n\n}\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .addCategoryButton {\n    background-color: #84c7ae;\n    border: none;\n    color: white;\n    padding: 9px 10px;\n    font-size: 13px;\n    border-radius: 4px;\n    cursor: pointer;\n    position: absolute;\n    right: 30px;\n    top: 15px;\n  }\n\n  .categoryTable td {\n    font-size: 16px;\n  }\n  .categoryTable th {\n    background-color: #deecdd;\n    position: sticky;\n    top: 0;\n    text-align: center;\n    padding: 4px 1px;\n  }\n}\n\n/* Small Desktops & Laptops: 1025px to 1439px */\n@media screen and (min-width: 1025px) and (max-width: 1440px) {\n  .categoryTable {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 60px;\n    position: relative;\n    font-size: 20px;\n  }\n  .categoryTable td {\n    font-size: 13px;\n  }\n  .categoryTable th {\n    background-color: #deecdd;\n    position: sticky;\n    top: 0;\n    text-align: center;\n    padding: 4px 1px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
